var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import createManualServiceEntry from '../../requests/service/createManualServiceEntry';
import ServiceEntryModel from "../../models/ServiceEntryModel";
/**
 *
 */
var CreateManualServiceEntryCommand = /** @class */ (function (_super) {
    __extends(CreateManualServiceEntryCommand, _super);
    function CreateManualServiceEntryCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param data Object
     * @param organisation OrganisationModel
     * @param intl
     * @return {*}
     */
    CreateManualServiceEntryCommand.prototype.execute = function (data, organisation, intl) {
        this.data = data;
        this.intl = intl;
        var promise = createManualServiceEntry(data, organisation);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    CreateManualServiceEntryCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.service.schema.manual.added' }), 'dark', true);
        var model = new ServiceEntryModel(response);
        Signals.ServiceEntryAdded.dispatch(model);
    };
    return CreateManualServiceEntryCommand;
}(Command));
export default CreateManualServiceEntryCommand;
